import React, { useState, useEffect } from "react";
import Modalapprove from "./../management/modalapprove";
import { Link } from "react-router-dom";
import { datausers } from "../queue/datalist";
import { getMasterStatus } from "./../../services/wms";

const Notapprove = () => {
  const [isOpen, setisOpen] = useState(false);
  const [list, setList] = useState([]);
  const [status, setstatus] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getMasterStatus();

      if (result.status === "success") {
        setstatus(result.data.list);
      }
    };
    loadData();
  }, []);

  const handleCancle = () => {
    setisOpen(false);
  };
  const handleonClickclose = (event) => {
    setList(false);
  };
  const handleonClikisopen = (id) => {

    setisOpen(true);
  };

  return (
    <>
      <Modalapprove onCancel={handleCancle} list={list} isOpen={isOpen} />
      <div className="card1 shadow page-titles">
        <span className="fs-4 fw-bold text-danger me-2">
          <i className="bi bi-x-circle-fill me-2"></i>รายการยังไม่อนุมัติ
        </span>
      </div>

      {datausers &&
        datausers.length > 0 &&
        datausers.map((item, index) => (
          <div
            className="card1 shadow  mt-2 border-top-0 border-start border-primary border-end-0 border-bottom-0 border border-2"
            key={index}
          >
            <div className="row m-1">
              <div className="col-xs-6 col-sm-4 col-md-2 lg-1 d-flex align-items-center">
                <span className="badge rounded-pill bg-primary  me-2">
                  {item.id}
                </span>

                <div
                  className="text-primary"
                  style={{ fontSize: 16, fontWeight: "bold" }}
                >
                  {item.name}
                </div>
              </div>

              <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                <div>
                  <h6>
                    รหัสลูกค้า :
                    <small style={{ fontSize: 14 }}> {item.codeID}</small>{" "}
                  </h6>
                </div>
                <div>
                  <h6>
                    รหัสบัตร :
                    <small style={{ fontSize: 14 }}> {item.IdentityID}</small>
                  </h6>
                </div>
                <div>
                  <h6>
                    ประเภท :
                    <small style={{ fontSize: 14 }}> {item.typeUser}</small>
                  </h6>
                </div>

                <div />
              </div>
              <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                <div>
                  <h6>
                    เลขที่ :<small style={{ fontSize: 14 }}> {item.NO}</small>
                    &nbsp; หมู่ :
                    <small style={{ fontSize: 14 }}> {item.Moo}</small>
                  </h6>
                </div>
                <div>
                  <h6>
                    ตำบล :<small style={{ fontSize: 14 }}> {item.tumbol}</small>
                  </h6>
                </div>
                <div>
                  <h6>
                    อำเภอ :<small style={{ fontSize: 14 }}> {item.umper}</small>
                  </h6>
                </div>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                <div>
                  <div>
                    <h6>
                      จังหวัด :
                      <small style={{ fontSize: 14 }}> {item.province}</small>
                    </h6>
                  </div>
                </div>
                <div>
                  <div>
                    <h6>
                      รหัสไปรษณีย์ :
                      <small style={{ fontSize: 14 }}> {item.codenumber}</small>
                    </h6>
                  </div>
                </div>
                <div>
                  <div>
                    <h6>
                      เบอร์โทร :
                      <small style={{ fontSize: 14 }}> {item.tel}</small>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-2 lg-3">
                <div>
                  <div>
                    <h6>
                      ชื่อชัญชี :
                      <small style={{ fontSize: 14 }}> {item.bookname}</small>
                    </h6>
                  </div>
                </div>
                <div>
                  <div>
                    <h6>
                      เลขที่บัญชี :
                      <small style={{ fontSize: 14 }}> {item.booknumber}</small>
                    </h6>
                  </div>
                </div>
                <div>
                  <div>
                    <h6>
                      ธนาคาร :
                      <small style={{ fontSize: 14 }}>{item.bankname}</small>
                      &nbsp; สาขา :
                      <small style={{ fontSize: 14 }}>{item.subbank}</small>
                    </h6>
                  </div>
                </div>
              </div>

              <div className="col-xs-6 col-sm-4 col-md-2 lg-1  d-flex align-items-center d-flex justify-content-end">
                <button
                  onClick={() => handleonClikisopen(item.id)}
                  type="button"
                  className="btn btn-danger btn-sm m-2"
                >
                  <i className="bi bi-x-circle me-2" />
                  ไม่อนุมัติ
                </button>
                <button
                  onClick={() => handleonClikisopen(item.id)}
                  type="button"
                  className="btn btn-primary btn-sm m-2"
                >
                  <i className="bi bi-eye-fill me-1" />
                  View
                </button>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default Notapprove;
